import { render, staticRenderFns } from "./StockIndustryView.vue?vue&type=template&id=08b1a100&scoped=true"
import script from "./StockIndustryView.vue?vue&type=script&lang=js"
export * from "./StockIndustryView.vue?vue&type=script&lang=js"
import style0 from "./StockIndustryView.vue?vue&type=style&index=0&id=08b1a100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1a100",
  null
  
)

export default component.exports